import { PRESET_AVATARS } from "../data/avatars";
import { OndaAvatar } from "./OndaAvatar";

export function AvatarPicker({ selected, onSelect, name, testIdPrefix = "avatar-option" }) {
  return (
    <div className="grid grid-cols-4 gap-3" data-testid="avatar-picker">
      {PRESET_AVATARS.map((url, i) => {
        const isSelected = selected === url;
        return (
          <button
            key={url}
            type="button"
            onClick={() => onSelect(url)}
            data-testid={`${testIdPrefix}-${i}`}
            aria-pressed={isSelected}
            aria-label={`Elegir avatar ${i + 1}`}
            className={
              "relative rounded-2xl p-0.5 transition-transform duration-200 " +
              (isSelected
                ? "scale-105 ring-2 ring-offset-2 ring-offset-[#0F172A]"
                : "hover:scale-105")
            }
            style={
              isSelected
                ? { boxShadow: "0 0 22px var(--accent-glow)", "--tw-ring-color": "var(--accent)" }
                : undefined
            }
          >
            <OndaAvatar src={url} name={name} size={64} />
            {isSelected && (
              <span
                className="absolute -top-1 -right-1 h-4 w-4 rounded-full q-accent-bg border-2 border-[#0F172A]"
                aria-hidden="true"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
